module.exports = __webpack_public_path__ + "img/0Q3A2889_L_BlackMatted.44adddfb.jpg";